<div class="cohort-container">

  <gen-cohort-viewer *ngIf="!editMode"
                     class="cohort-viewer-panel"
                     [cohort]="cohort"
                     [allowEdit]="true"
                     [enableCohortDragging]="enableCohortDragging"
                     (cloneMe)="onCloneMe()"
                     (deleteMe)="onDeleteMe()"
                     (editMe)="enterEditMode()"
  >
  </gen-cohort-viewer>

  <gen-cohort-editor *ngIf="editMode"
                     class="cohort-editor-panel"
                     [cohort]="cohort"
                     (cloneMe)="onCloneMe()"
                     (deleteMe)="onDeleteMe()"
                     (closeMe)="enterViewMode()"
  >
  </gen-cohort-editor>

</div>
